//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      checked: false,
      visible: false
    };
  },
  computed: {
    config: function config() {
      return this.$store.state.projectConfig;
    }
  },
  methods: {
    show: function show() {
      this.visible = true;
      this.checked = false;
    },
    handleAgree: function handleAgree() {
      this.$emit('agree');
      this.visible = false;
    }
  }
};